module.exports = __webpack_public_path__ + "static/img/运营级场景_角标_image@2x.9c1d76f8.png";